import { Api } from 'utils';

class ClinicService {

	static admin = {
		get: async (params?: any) => Api.createResponse('admin/clinic',params),
		download: async (params?: any) => Api.createResponse('admin/clinic/download',params),
		create: async (params?: any) => Api.createResponse('admin/clinic/create',params),
		update: async (params?: any) => Api.createResponse('admin/clinic/update',params),
		delete: async (params?: any) => Api.createResponse('admin/clinic/delete',params),
		suspend: async (params?: any) => Api.createResponse('admin/clinic/suspend',params)
	}

}

export default ClinicService;